// The Briefing while a comparison is open (#77, frames 40006824:265349 → 40006859:277503).
//
//   📄  Briefing comparison
//   Sources
//   🗂  Louis Vuitton Sunglasses            Open ↗
//   🗂  Prada Sunglasses                    Open ↗
//
// Stage 1's strip is about the ongoing ("Briefing Buy sunglasses") and names what has been TICKED
// under "Selected". The moment the comparison itself is on screen the subject changes: the frames
// retitle the strip "Briefing comparison" and relabel that same list "Sources" — the packs are no
// longer a selection waiting to be acted on, they are what the answer was built FROM.
//
// Same rows/selected shape as every other briefing, so the strip renders it with no new template:
// only the label above the list differs, which is why `selectedLabel` exists (lib/briefings/rows.js).

import { briefing } from './rows'

/**
 * @param title the comparison's own name — "Prada vs Louis Vuitton" (comparison/title)
 * @param packs the packs it was built from — the comparison store's picks
 * @returns a briefing, or null when there is no comparison to describe
 */
export function comparisonBriefing(title, packs) {
  const sources = (packs || [])
    .filter(p => p && p.id)
    .map(p => ({ id: String(p.id), title: String(p.title || 'Research pack') }))
  // No title and no sources is not a comparison — the strip falls back to the story underneath
  // rather than heading a briefing with nothing under it.
  if (!String(title || '').trim() && !sources.length) return null

  return briefing({
    kind: 'comparison',
    // The frames write it lower-case ("Briefing comparison"), not after the comparison's own name:
    // the name is already the question chip in the middle, and repeating it here would give the
    // strip a title that changes width with every selection.
    title: 'Briefing comparison',
    titleIcon: 'receipt-text',
    rows: [],
    selected: sources.length ? sources : null,
    selectedLabel: 'Sources',
  })
}

export default comparisonBriefing
